import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import {
    SpsCheckboxComponent,
    SpsConditionalFieldComponent,
    SpsFieldsetComponent,
    SpsFieldsetErrorComponent,
    SpsInputGroupComponent,
    SpsLabelComponent,
    SpsLabelErrorComponent,
    SpsLabelHelpComponent,
    SpsRadioButtonComponent,
    SpsTextareaComponent,
    SpsTextInputComponent,
    SpsToggleComponent,
} from "../components/index";
import { SpsTooltipModule } from "./sps-tooltip.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SpsTooltipModule
    ],
    declarations: [
        SpsCheckboxComponent,
        SpsConditionalFieldComponent,
        SpsFieldsetComponent,
        SpsFieldsetErrorComponent,
        SpsInputGroupComponent,
        SpsLabelComponent,
        SpsLabelErrorComponent,
        SpsLabelHelpComponent,
        SpsRadioButtonComponent,
        SpsTextInputComponent,
        SpsTextareaComponent,
        SpsToggleComponent
    ],
    exports: [
        SpsCheckboxComponent,
        SpsConditionalFieldComponent,
        SpsFieldsetComponent,
        SpsFieldsetErrorComponent,
        SpsInputGroupComponent,
        SpsLabelComponent,
        SpsLabelErrorComponent,
        SpsLabelHelpComponent,
        SpsRadioButtonComponent,
        SpsTextInputComponent,
        SpsTextareaComponent,
        SpsToggleComponent
    ]
})
export class SpsFormsModule {}
